import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IFormulaireGroupeAccordeonClass } from '../../../../../core/services/formulaire/formulaire-groupe-accordeon.service';
import { IFormulaireGroupeClass } from '../../../../../core/services/formulaire/formulaire-groupe.service';
import { IMenuItemForage, IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IFormulaireItemSautDeColonneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-colonne.service';
import { IStateParamsService } from 'angular-ui-router';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
//import { IRoute } from '../../../../../core/interfaces/route.interface';

interface IPageAl0002 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    dlpMultiOccurrenceOptions: IMultiOccurrenceOptions;
    dldMultiOccurrenceOptions: IMultiOccurrenceOptions;
    dlrMultiOccurrence: IMultiOccurrence;
    dlrmultiOccurrenceOptions: IMultiOccurrenceOptions;
    avimultiOccurrenceOptions: IMultiOccurrenceOptions;
    dfcmultiOccurrenceOptions: IMultiOccurrenceOptions;
    dsemultiOccurrenceOptions: IMultiOccurrenceOptions;
    resmultiOccurrenceOptions: IMultiOccurrenceOptions;
    cpeMenus: Array<IMenuItemForage>;
    formulaireCom: IFormulaire;
    formulaireCriteres: IFormulaire;
}

/* @ngInject */
export default function Al0002Controller(
    Formulaire: IFormulaireClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    cs0001Route: IRoute,
    cs0003Route: IRoute,
    al2015Route: IRoute,
    $stateParams: IStateParamsService,
    FormulaireItemSautDeColonne: IFormulaireItemSautDeColonneClass,
    al2005Route: IRoute,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    FormulaireGroupeAccordeon: IFormulaireGroupeAccordeonClass,
    FormulaireGroupe: IFormulaireGroupeClass,
    MenuItemEcran: IMenuItemEcranClass,
    MenuItemForage: IMenuItemForageClass,
    Menu: IMenuClass,
    al0004Route: IRoute,
    al0006Route: IRoute,
    al0003Route: IRoute,
    mr0008Route: IRoute
) {
    const vm: IPageAl0002 = this;
    //Zone message
    vm.formulaireMsg = new Formulaire('zone_msg', [
        new FormulaireItem('zone_msg', {
            largeur: 100,
            titre: ' ',
            enableCount: true,
            disabled: true
        })
    ]);
    vm.cpeMenus = [
        new MenuItemForage(
            'LBL_DEM',
            cs0001Route.NAME,
            (data: any) => ({
                ecran: '00-2',
                demcleint: vm.monoOccurrence.data.demcleint,
                dalcleint:  vm.monoOccurrence.data.dalcleint,
                efface_criteres: true
            }),
            {
                icon: 'local_hospital',
                iconButton: false,
                fonction: 'BOUSANTE',
                compteur: (data: any) => (vm.monoOccurrence.data.nbrdiagmed > 0) ? vm.monoOccurrence.data.nbrdiagmed : undefined,
                secondaire: true
            }
        ),
        new MenuItemForage(
            'LBL_SIM',
            al2005Route.NAME,
            (data: any) => ({
                id: vm.monoOccurrence?.data.dalcleint,
                dalcleint:vm.monoOccurrence?.data.dalcleint,
                demcleint: vm.monoOccurrence.data.demcleint,
                lemcleint: vm.monoOccurrence.data.lemcleint,
                tdlcleint: vm.monoOccurrence.data.tdlcleint,
                dalnumdoc: vm.monoOccurrence.data.dalnumdoc,
                efface_criteres: true
            }),
            {
                icon: 'analytics',
                iconButton: false,
                fonction: 'BOUSIM',
                secondaire: true
            }
        )
    ];

 vm.monoOccurrenceOptions = {
            fonctions: {
                importation: true
            },
            actionsMore: new Menu([               
                new MenuItemEcran(
                    'LBL_CAL_CSST',
                    al2015Route.NAME,
                    (data: any) => ({
                        id: data.aut__dltcleint,
                        dalcleint: data.dalcleint
                    }),
                    {
                        icon: 'bar_chart',
                        iconButton: false,
                        fonction: 'BOUCALCSST',
                        onClose: () => {
                            vm.monoOccurrence.fetchData();
                        }
                    }
                )
            ])
        };

    vm.formulaireAld = new Formulaire(' ',[
        new FormulaireItem('dalnumdoc', {
            largeur: 33,
            required: false,
            disabled: true
        }),
        new FormulaireItem('dalseqmodcou', {
            largeur: 33,
            required: false
        }),
        new FormulaireItem('tdlcleint', {
            largeur: 33,
            required: true,
            modifAllow: false
        }),        
        new FormulaireItem('demcleint', {
            largeur: 33,
            required: true,
            default: $stateParams.demcleint,
            modifAllow: false
        }),
        new FormulaireItem('lemcleint', {
            largeur: 33,
            required: true,
            modifAllow: false,
            resourceParams: (data: any) => ({ demcleint: data.demcleint })
        }),
        new FormulaireItem('ttccleint', {
            largeur: 33,
            required: false,
            modifAllow: false
        }),        
        new FormulaireItemSautDeLigne(),
        new FormulaireGroupe('Dates', new Formulaire([
            new FormulaireItem('daldatouv', {
                largeur: 33,
                required: false
            }),
            new FormulaireItem('daldatfer', {
                largeur: 33,
                required: false
            }),
            new FormulaireItem('daldatass', {
                largeur: 33,
                required: false,
                disabled: true
            }),
            new FormulaireItem('daldatdeb', {
                largeur: 33,
                required: false,
                disabled: true
            }),
            new FormulaireItem('daldatret', {
                largeur: 33,
                required: false,
                disabled: true
            }),
            new FormulaireItem('daldatretprg', {
                largeur: 33,
                required: false,
                disabled: true
            }),
            new FormulaireItemSautDeColonne({ largeur: 33 }),
            new FormulaireItemSautDeColonne({ largeur: 33 }),
            new FormulaireItem('daldatrec', {
                largeur: 33,
                required: false,
                disabled: true
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('dalprcdif', {
                largeur: 33,
                required: false,
                disabled: (data: any) => data.vaetdltyp != 'DIFF'
            }),
            new FormulaireItem('acccleint', {
                largeur: 50,
                menu: [
                    new MenuItemForage('BTN_FORAGE_ACCIDENT', cs0003Route.NAME, () => ({ id: vm.monoOccurrence.data.trncleint_acc }), {
                        hidden: () => !vm.monoOccurrence.data.acccleint,
                        fonction: 'BTN_ACCIDENT'
                    })
                ]
            }),
            new FormulaireItem('adresse', {
                hidden: true
            }),
            new FormulaireGroupeAccordeon('Assurance', new Formulaire([
                new FormulaireItem('dalsalann', {
                    largeur: 33,
                    required: false
                }),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('placod', {
                    largeur: 33,
                    required: false,
                    disabled: true
                }),
                new FormulaireItem('pladsc', {
                    largeur: 33,
                    required: false,
                    disabled: true
                }),
                new FormulaireItem('planumref', {
                    largeur: 33,
                    required: false,
                    disabled: true
                }),
                new FormulaireItem('daadatadm', {
                    largeur: 33,
                    required: false,
                    disabled: true
                })
            ]), { hidden: (data: any) => (data.vaetdltyp !== 'ASAL') }
            )
        ]))

    ]);

    vm.formulaireCom = new Formulaire('LBL_FIN', [
        new FormulaireItem('dalcom', {
            largeur: 100, hidden: !ecranDetails.valeurs.flgcom,
            enableCount: true,
            disabled: false
        })
    ]);

    vm.dlpMultiOccurrenceOptions = {
        bloc: 'dlp',        
        colonnesVisibles: [
            { nom: 'prfcod', largeur: 130 },
            { nom: 'prfdscabr', largeur: 130 },
            { nom: 'dlpdatdeb', largeur: 130 },
            { nom: 'dlpdatfin', largeur: 130 },
            { nom: 'nbrjrs', largeur: 130 },
            { nom: 'dlpseqmod', largeur: 130 },
            { nom: 'dlpflgact', largeur: 130 }
        ],
        actionsNouveaux: new Menu([
            new MenuItemForage(al0003Route.NAME, (data: any) => ({
                dalcleint: vm.monoOccurrence.data.dalcleint,
                tdlcleint: vm.monoOccurrence.data.tdlcleint,
                lemcleint: vm.monoOccurrence.data.lemcleint,
                dalseqmodcou: vm.monoOccurrence.data.dalseqmodcou,
                eclcleint: vm.monoOccurrence.data.eclcleint

            }), {
                fonction: 'BOUNOUV',
                icon: '',
                disabled: ecranDetails.valeurs.flgoff
            })
        ]),
        navigatePage: al0003Route.NAME,
        navigateParams: (data: any) => ({
            id: data.dlpcleint,
            dalcleint: data.$ancetre.dalcleint,
            tdlcleint: data.$ancetre.tdlcleint,
            lemcleint: data.$ancetre.lemcleint,
            dalseqmodcou: vm.monoOccurrence.data.dalseqmodcou,
            eclcleint: vm.monoOccurrence.data.eclcleint
        }),
    }
    

    vm.dldMultiOccurrenceOptions = {
        bloc: 'dld',
        colonnesVisibles: [
            { nom: 'dlddat', largeur: 130 },
            { nom: 'prfcod', largeur: 130 },
            { nom: 'prfdscabr', largeur: 130 },
            { nom: 'alinbrann', largeur: 130 },
            { nom: 'alinbrmoi', largeur: 130 },
            { nom: 'alinbrjrs', largeur: 130 },
            { nom: 'alidsc', largeur: 130 },
            { nom: 'vacvalcle', largeur: 130 },
            { nom: 'vacdsc', largeur: 130 },
            { nom: 'dldcom', largeur: 130 },
            { nom: 'dldflgact', largeur: 130 }
        ]
    };
    
   // avantages sociaux
    vm.dlrmultiOccurrenceOptions = {
        bloc: 'dlr',
        fonctions: {
            supprime: (data : any) => data.flgiud
        },        
        colonnesVisibles: [
            { nom: 'dlrdatvig', largeur: 130 },
            { nom: 'rcecod', largeur: 130 },
            { nom: 'rcedscabr', largeur: 130 },
            { nom: 'cotcod', largeur: 130 },
            { nom: 'cotdsc', largeur: 130 },
            { nom: 'dlrseqmod', largeur: 130 },
            { nom: 'dlrflgact', largeur: 130 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('dlrdatvig', {
                required: true,
                largeur: 25,
            }),
            new FormulaireItem('rcecleint', {
                disabled: false,
                required: true,
                largeur: 25,
                resourceParams: (data: any) => ({
                    tdlcleint: data.$ancetre.tdlcleint,
                    daldatdeb: data.$ancetre.daldatdeb,
                    dalcleint: data.$ancetre.dalcleint,
                    demcleint: data.$ancetre.demcleint
                })
            }),
            new FormulaireItem('cotcleint', {
                disabled: false,
                required: true,
                largeur: 25,
                resourceParams: (data: any) => ({
                    tdlcleint: data.$ancetre.tdlcleint,
                    rcecleint: data.rcecleint
                })
            }),
            new FormulaireItem('dlrflgact', {
                required: false,
                disabled: false,
                default: true,
                largeur: 25
            }),
            new FormulaireItem('dlrseqmod', { largeur: 33, default: () => vm.monoOccurrence.data.dalseqmodcou }),

        ])
    };
    // Avis
    vm.avimultiOccurrenceOptions = {
        bloc: 'avi',
        fonctions: {
            edition: false
        },
        navigatePage: mr0008Route.NAME,
        navigateParams: (data: any) => ({
            id: data.apacleint,
            cleintref: data.avicleintpar,
            stamnetab: data.stamnetabpar,
            vaesystypavi: data.vaesystypavi,
            typsai: 'JRS',
            supprime: 0,
            vaebmtent: data.vaebmtent
        }),
        colonnesVisibles: [
            { nom: 'avidatavi', largeur: 110 },
            { nom: 'avitxt', largeur: 330 },
            { nom: 'aviflgenv', largeur: 120 },
            { nom: 'aviflgdet', largeur: 120 },
        ],
        colonnesCachees: ['avicleint', 'vaebmtent', 'avicleintref', 'stamnetabpar', 'vaesystypavi', 'avicleintpar', 'apacleint']
    }
    // Facturation
    vm.dfcmultiOccurrenceOptions = {
        bloc: 'dfc',
        navigatePage: al0006Route.NAME,
        navigateParams: (data: any) => ({
            id: data.dfccleint,
            dfccleint: data.dfccleint,
            dalcleint: data.$ancetre.dalcleint,
            demcleint: data.$ancetre.demcleint
        }),
        actionsNouveaux: new Menu([
            new MenuItemForage(al0006Route.NAME, (data: any) => ({
                demcleint: vm.monoOccurrence.data.demcleint,
                dalcleint: vm.monoOccurrence.data.dalcleint

            }), {
                fonction: 'BOUNOUV',
                icon: ''
            })
        ]),
        colonnesVisibles: [
            { nom: 'dfcdatdeb', largeur: 110 },
            { nom: 'dfcdatfin', largeur: 110 },
            { nom: 'dfcdatenv', largeur: 110 },
            { nom: 'vacvalcle', largeur: 130 },
            { nom: 'vacdsc', largeur: 230 },
            { nom: 'dfcprcabs', largeur: 130 },
            { nom: 'dfcflgemrass', largeur: 180 },
            { nom: 'dfcflgemrfpn', largeur: 150 },
            { nom: 'dfcflgempass', largeur: 180 },
            { nom: 'dfcflgempfpn', largeur: 150 },
        ],
        colonnesCachees: ['dfccleint', 'eadcleint', 'dalcleint']
    }
    // Salaire exception
    vm.dsemultiOccurrenceOptions = {
        bloc: 'dse',
        colonnesVisibles: [
            { nom: 'dsedatvig', largeur: 110 },
            { nom: 'dsesal', largeur: 190 },
            { nom: 'unccod', largeur: 130 },
            { nom: 'uncdsc', largeur: 130 },
            { nom: 'dseseqmod', largeur: 130 },
            { nom: 'dseflgact', largeur: 130 },
        ],
        formulaire: new Formulaire([
            new FormulaireItem('dsedatvig', {
                required: true,
                largeur: 15
            }),
            new FormulaireItem('dsesal', {
                required: true,
                largeur: 15
            }),
            new FormulaireItem('unccleint', {
                required: true,
                largeur: 33
            }),
            new FormulaireItem('dseseqmod', {
                required: false,
                disabled: true,
                largeur: 15,
                default: () => (vm.monoOccurrence.data.dalseqmodcou)
            }),
            new FormulaireItem('dseflgact', {
                required: false,
                default: 1,
                disabled: false,
                largeur: 15
            })

        ])
    }
    // Résumé
    vm.resmultiOccurrenceOptions = {
        bloc: 'res',
        navigatePage: al0004Route.NAME,
        navigateParams: (data: any) => ({
            id: data.dlhcleint,
            dlhcleint: data.dlhcleint,
            dlpcleint: data.dlpcleint,
            dalcleint: data.$ancetre.dalcleint

        }),
        colonnesVisibles: [
            { nom: 'prfcod', largeur: 130 },
            { nom: 'prfdscabr', largeur: 190,  menu: [
                new MenuItemForage(
                    'LBL_CUMULATIF',
                    al0003Route.NAME,
                    (rowData: any) => ({
                        id: rowData.dlpcleint,
                        dalcleint: rowData.dalcleint
                    }),
                    {
                        fonction: 'CUMULATIF',
                        icon: 'launch',
                        iconButton: true
                    }
                )
            ] },            
            { nom: 'vaedlitypdatald', largeur: 130 },
            { nom: 'dlidatdeb', largeur: 130 },
            { nom: 'dlidatfin', largeur: 130 },
            { nom: 'dlhdatvig', largeur: 130 },
            { nom: 'dlhpctrep', largeur: 150 },
            { nom: 'dhdqteabs', largeur: 140 },
            { nom: 'dhdqtetra', largeur: 130 },
        ],
        colonnesCachees: ['dlhcleint', 'dlpcleint', 'dalcleint']
    }
}
